import React from 'react';
import {BuyerInventoryReportVO} from "../../../types/model/valueObject/inventory/BuyerInventoryReportVO";
import {BuyerCurrentInventoryCardListItem} from "./BuyerCurrentInventoryCardListItem";
import {withLoader} from "../../hocs/withLoader";
import {LocationCardSkeleton} from "../../common/reports/loadingSkeletons/LocationCardSkeleton";

type BuyerCurrentInventoryCardListProps = {
  items?: BuyerInventoryReportVO[];
  expandByIndex: Array<boolean>;
  onToggleExpand: (index: number) => void;
}

const BuyerCurrentInventoryCardList = ({
  items,
  expandByIndex,
  onToggleExpand
}: BuyerCurrentInventoryCardListProps) => {
  if (!items?.length) {
    return null;
  }

  return <>
    {
      items.map((item, index) =>
        <BuyerCurrentInventoryCardListItem
          key={index}
          item={item}
          expanded={expandByIndex[index]}
          onToggleExpand={() => onToggleExpand(index)}
        />
      )
    }
  </>
}

const skeletonLoader = () => Array.from({ length: 10 }).map((_, index) => (
  <LocationCardSkeleton key={index} />
));

const BuyerCurrentInventoryCardListWithLoader = withLoader(BuyerCurrentInventoryCardList, skeletonLoader);

export {
  BuyerCurrentInventoryCardList,
  BuyerCurrentInventoryCardListWithLoader
};
